import { render, staticRenderFns } from "./OrganizationsSelection.vue?vue&type=template&id=5151800c&scoped=true&"
import script from "./OrganizationsSelection.vue?vue&type=script&lang=js&"
export * from "./OrganizationsSelection.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationsSelection.vue?vue&type=style&index=0&id=5151800c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5151800c",
  null
  
)

export default component.exports